module.exports = __webpack_public_path__ + "img/bingo_ball-3.5331fa47.png";